import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outsource-calendar',
  templateUrl: './outsource-calendar.component.html',
  styleUrls: ['./outsource-calendar.component.css']
})
export class OutsourceCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
